var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$mq,attrs:{"id":"app"}},[(_vm.layout === 'app')?_c('router-view'):_c('div',[_c('mq-layout',{attrs:{"mq":"lg+"}},[_c('LayoutWeb')],1),_c('mq-layout',{attrs:{"mq":['sm', 'md']}},[_c('LayoutMobile')],1)],1),_c('Snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }